function add_get_param_to_url(param, value) {
    let currentState = history.state || {};

    currentState[param] = value;

    // Vytvor nový objekt pre query parametre, odstráň duplicity
    let queryParams = {};
    let currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((val, key) => {
        queryParams[key] = val;
    });

    // Pridaj alebo aktualizuj parameter v objekte
    queryParams[param] = value;

    // Vytvor nový URL s aktualizovanými query parametrami
    let newUrl = window.location.pathname + '?' + $.param(queryParams);

    // Zmeň URL pomocou pushState
    history.pushState(currentState, '', newUrl);
}

function remove_get_param_from_url(param) {
    let currentState = history.state || {};

    // Vytvor nový objekt pre query parametre, odstráň duplicity
    let queryParams = {};
    let currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((val, key) => {
        if (key !== param) {
            queryParams[key] = val;
        }
    });

    // Vytvor nový URL s aktualizovanými query parametrami
    let newUrl = window.location.pathname + '?' + $.param(queryParams);

    // Zmeň URL pomocou pushState
    history.pushState(currentState, '', newUrl);
}

function get_get_param(param) {
    let currentParams = new URLSearchParams(window.location.search);
    return currentParams.get(param);
}
